interface onePartyElement {
  competed: number
  won: number
  improved: number
}
export const partyData: { [key: string]: onePartyElement } = require('./2019_partyFacts.json')